import { API } from '@xbto/api-client';
import {
  AccountCustodyEmpty,
  AccountFundEmpty,
  AccountTradingEmpty,
} from '@xbto/universal-components';
import { useTrackEvent } from 'common';
import { FC, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSearchParam } from 'react-use';
import { APP_ROUTES } from '~/routes';
// import { AccountFundNoHolding } from '@xbto/universal-components';

export const Splash: FC = () => {
  /**
   * Hooks
   */
  const type = useSearchParam('type');
  const navigate = useNavigate();
  const trackEvent = useTrackEvent();
  useEffect(() => {
    if (type) {
      return;
    }
    // TODO
  }, [type]);

  /**
   * Methods
   */
  const onViewOurFunds = useCallback(() => {
    trackEvent('explore-funds_cta_clicked', { source: 'empty_state' });
    navigate(`${APP_ROUTES.AUTH_MARKETS}?assetType=Funds`);
  }, [navigate, trackEvent]);

  // const onViewStatements = useCallback(() => {
  //   navigate(APP_ROUTES.AUTH_STATEMENTS);
  // }, [navigate]);

  const onViewCrypto = useCallback(() => {
    navigate(`${APP_ROUTES.AUTH_MARKETS}?assetType=Crypto`);
  }, [navigate]);

  const onViewCustody = useCallback(() => {
    window.open('https://www.xbto.com/services/custody-services', '_blank');
  }, []);

  /**
   * DOM
   */
  if (type === API.AccountType.Fund) {
    return (
      <div className={'mb-6 sm:mx-0 md:mx-4 lg:mx-6'}>
        <AccountFundEmpty onPressCta={onViewOurFunds} />
        {/*<AccountFundNoHolding onPressCta={onViewStatements} />*/}
      </div>
    );
  }

  if (type === API.AccountType.Custody || type === API.AccountType.Vault) {
    return (
      <div className={'mb-6 sm:mx-0 md:mx-4 lg:mx-6'}>
        <AccountCustodyEmpty onPressCta={onViewCustody} />
      </div>
    );
  }

  return (
    <div className={'mb-6 sm:mx-0 md:mx-4 lg:mx-6'}>
      <AccountTradingEmpty onPressCta={onViewCrypto} />
    </div>
  );
};
